import {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';

import { MenuItem } from 'types/MenuItem';

export interface NavigationContext {
  activeNavigationItem: MenuItem;
  setActiveNavigationItem: Dispatch<SetStateAction<MenuItem>>;
  selectedFloor: number | null;
  setSelectedFloor: Dispatch<SetStateAction<number | null>>;
  selectedAptId: string | null;
  setSelectedAptId: Dispatch<SetStateAction<string | null>>;
}

interface NavigationContextProps {
  children: ReactNode;
}

export const NavigationContext = createContext<NavigationContext>({
  activeNavigationItem: 0,
  setActiveNavigationItem: () => {},
  selectedFloor: null,
  setSelectedFloor: () => {},
  selectedAptId: null,
  setSelectedAptId: () => {},
});

export const NavigationProvider = ({ children }: NavigationContextProps) => {
  const [activeNavigationItem, setActiveNavigationItem] = useState<MenuItem>(0);
  const [selectedFloor, setSelectedFloor] = useState<number | null>(null);
  const [selectedAptId, setSelectedAptId] = useState<string | null>(null);

  return (
    <NavigationContext.Provider
      value={{
        activeNavigationItem,
        setActiveNavigationItem,
        selectedFloor,
        setSelectedFloor,
        selectedAptId,
        setSelectedAptId,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};
